import { createEl } from "@/client/utils/createEl";
import * as styles from "./wave-spinner.css";

/**
 * A loading indicator in the shape of a small wave: five bars rising and
 * falling in sequence, in the text colour, so it reads as sound rather than as
 * a generic spinner. `label` is for assistive tech only.
 */
export const createWaveSpinner = (label = "Loading"): HTMLElement =>
    createEl(
        "span",
        styles.spinner,
        styles.barDelays.map((delay) => createEl("span", `${styles.bar} ${delay}`)),
        (el) => {
            el.setAttribute("role", "status");
            el.setAttribute("aria-label", label);
        },
    );
